import React from 'react';
import { ClassicEditorContextProviderLoader } from '@confluence-classic/confluence-fabric-editor/src/components/ClassicEditorContextProvider/index.js';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { EmbeddedEditPageLoader } from '@confluence/embedded-confluence/entry-points/EmbeddedEditPage.ts';

import { navdexEnd } from '../naxdev.js';

export const EditPageEmbedRoute: {
	({ params: { contentId, spaceKey }, query: { draftShareId } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS({ params: { contentId, spaceKey } }: RouteMatch): {
		Screen: {
			showPremiumOnboarding: boolean;
			screenEvent: {
				attributes: {
					navdexPointType: string;
				};
				name: string;
				id: string;
			};
			pageState: {
				contentId: string;
				spaceKey: string;
				contentType: string;
			};
		};
		MainLayout: boolean;
		BannerContext: {
			includeTopNav: boolean;
		};
	};
} = ({
	params: { contentId, spaceKey },
	query: { draftShareId },
}: RouteMatch): React.JSX.Element => (
	<ClassicEditorContextProviderLoader>
		<EmbeddedEditPageLoader
			contentId={contentId}
			spaceKey={spaceKey}
			draftShareId={String(draftShareId)}
			contentType="page"
		/>
	</ClassicEditorContextProviderLoader>
);

EditPageEmbedRoute.NAVIGATION_PARAMS = ({
	params: { contentId, spaceKey },
}: RouteMatch): {
	Screen: {
		showPremiumOnboarding: boolean;
		screenEvent: {
			attributes: {
				navdexPointType: string;
			};
			name: string;
			id: string;
		};
		pageState: {
			contentId: string;
			spaceKey: string;
			contentType: string;
		};
	};
	MainLayout: boolean;
	BannerContext: {
		includeTopNav: boolean;
	};
} => ({
	Screen: {
		showPremiumOnboarding: false,
		screenEvent: {
			name: 'editPageEmbedScreen',
			id: contentId,
			...navdexEnd,
		},
		pageState: { contentId, spaceKey, contentType: 'page' },
	},
	MainLayout: false,
	BannerContext: { includeTopNav: false },
});
